module.exports = __webpack_public_path__ + "static/media/five-dashes-stroke.1fa3acbb.svg";